import { Link } from 'react-router-dom';
import NewsletterForm from '../../../components/feature/NewsletterForm';

export default function CTASection() {
  const handleExpertClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const widgetButton = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widgetButton) {
      widgetButton.click();
    }
  };

  return (
    <section className="py-24 bg-gradient-to-br from-teal-600 via-teal-700 to-cyan-800 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Prêt à transformer votre entreprise avec l'IA ?
          </h2>
          <p className="text-xl text-teal-50 mb-8 max-w-3xl mx-auto">
            Rejoignez des centaines d'entreprises qui utilisent déjà Agent IA Pro pour automatiser leurs processus et multiplier leurs résultats.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/signup"
              className="min-w-[44px] min-h-[48px] px-8 py-4 bg-white text-teal-700 rounded-lg font-semibold hover:bg-gray-50 transition-all hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              Créer mon compte gratuitement
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <a
              href="#"
              onClick={handleExpertClick}
              className="min-w-[44px] min-h-[48px] px-8 py-4 bg-teal-800 text-white rounded-lg font-semibold hover:bg-teal-900 transition-all border-2 border-white/20 whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              Parler à un expert
              <i className="ri-phone-line ml-2"></i>
            </a>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center border border-white/20">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-user-line text-3xl text-white"></i>
            </div>
            <div className="text-4xl font-bold text-white mb-2">500+</div>
            <div className="text-teal-50">Entreprises équipées</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center border border-white/20">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-robot-2-line text-3xl text-white"></i>
            </div>
            <div className="text-4xl font-bold text-white mb-2">2000+</div>
            <div className="text-teal-50">Agents IA déployés</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center border border-white/20">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-3xl text-white"></i>
            </div>
            <div className="text-4xl font-bold text-white mb-2">10 000+</div>
            <div className="text-teal-50">Heures économisées</div>
          </div>
        </div>

        {/* Newsletter Section */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-white/20">
          <div className="max-w-2xl mx-auto text-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-mail-line text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-white mb-4">
              Restez à la pointe de l'innovation IA
            </h3>
            <p className="text-teal-50 mb-8">
              Recevez nos dernières actualités, conseils d'experts et offres exclusives directement dans votre boîte mail.
            </p>
            <NewsletterForm variant="inline" />
            <p className="text-sm text-teal-100 mt-4">
              Pas de spam. Désinscription possible à tout moment.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}